module.exports = __webpack_public_path__ + "img/scene16.0b8c12c7.gif";